import { render } from "./sys-dict-list.vue?vue&type=template&id=2be9b8f7&scoped=true"
import script from "./sys-dict-list.vue?vue&type=script&lang=js"
export * from "./sys-dict-list.vue?vue&type=script&lang=js"

import "./sys-dict-list.vue?vue&type=style&index=0&id=2be9b8f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be9b8f7"]])

export default __exports__